<script setup>
import { Head, Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import AppLayout from '../../Layouts/AppLayout.vue'

const { t } = useI18n()
</script>

<template>
  <Head :title="t('messages.eid.mismatch_title')" />

  <AppLayout>
    <div class="flex justify-center mt-16 px-4">
      <div class="max-w-md w-full">
        <Card>
          <template #content>
            <div class="flex flex-col gap-3">
              <h1 class="text-xl font-medium text-gray-900 m-0" data-testid="invitation-id-code-mismatch">
                {{ t('messages.eid.mismatch_title') }}
              </h1>
              <p class="text-sm text-gray-600 m-0 leading-relaxed">
                {{ t('messages.eid.mismatch_description') }}
              </p>
              <div class="flex justify-end mt-2">
                <Link :href="route('login')">
                  <Button text :label="t('messages.invitations.accept.go_to_login')" class="w-auto!" />
                </Link>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
  </AppLayout>
</template>
